import AdSlot from "./AdSlot";
import { adsConfig } from "./ads";

export default function ArticleAd({ index, totalSections, articleSlug, placement = "article", className = "" }) {
  if (placement === "top") return null;

  if (["bottom", "sidebar"].includes(placement)) {
    return <AdSlot placement={placement} articleSlug={articleSlug} className={className} />;
  }

  const total = Number(totalSections) || 0;
  const isLongEnough = total >= Math.max(6, Math.ceil(adsConfig.thresholds.articleScrollDepth / 2));
  if (!isLongEnough) return null;

  const middleIndex = Math.max(2, Math.ceil(total / 2));
  if (index !== middleIndex) return null;

  return <AdSlot placement="article" articleSlug={articleSlug} className={className} />;
}
